import { Directive, HostBinding, HostListener, inject, input, OnInit } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';

@Directive({
  standalone: true,
  selector: '[ciphrNavigationLink]',
  exportAs: 'ciphrNavigationLink',
  hostDirectives: [RouterLink, RouterLinkActive],
})
export class NavigationLinkDirective implements OnInit {
  private readonly router = inject(Router);
  private readonly locationStrategy = inject(LocationStrategy);
  private readonly routerLink = inject(RouterLink, { self: true });
  private readonly routerLinkActive = inject(RouterLinkActive, { self: true });

  link = input.required<string>({ alias: 'ciphrNavigationLink' });
  private internalRoute?: string;

  @HostBinding('href') href?: string;

  get active(): boolean {
    return this.routerLinkActive.isActive;
  }

  @HostListener('chr-action')
  onAction(): void {
    if (this.internalRoute) {
      this.router.navigateByUrl(this.internalRoute);
    }
  }

  ngOnInit() {
    const baseHref = this.locationStrategy.getBaseHref();
    const baseHrefWithoutTrailingSlash = baseHref ? baseHref.slice(0, -1) : '';
    const link = this.link();

    const shouldUseRouterLink =
      (!!baseHrefWithoutTrailingSlash && link.startsWith(baseHrefWithoutTrailingSlash)) ||
      link.startsWith('/admin') ||
      link.startsWith('/profile');

    if (shouldUseRouterLink) {
      const cleanLink = baseHrefWithoutTrailingSlash ? link.replace(baseHrefWithoutTrailingSlash, '') : link;
      this.routerLink.routerLink = cleanLink;
      this.internalRoute = cleanLink;
    } else {
      this.href = link;
    }
  }
}
